import { Box } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/dist/client/router";
import React, { useEffect, useState } from "react";
import UiButton from "../../components/atoms/UiButton";
import BlogSection from "../../components/homePage/BlogSection";
import QASection from "../../components/homePage/Q&A";
import WhyShouldHire from "../../components/homePage/WhyShouldHire";
import Filterbar from "../../components/organisms/Filterbar";
import CardsBox from "../../components/templates/CardsBox";
import HeroSection from "../../components/templates/HeroSection";
import Layout from "../../components/templates/Layout";
import { homePageData } from "../../lib/constants";
import styles from "../../styles/components/homePage.module.css";
import { Mongo } from "../../util/MongoScript";
import CircleLoader from "../../components/CircleLoader";

function Home({ data }) {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  const { keyword } = router.query;
  //new structure
  const artistList = JSON.parse(data?.artistList);
  const serviceTypesList = JSON.parse(data?.serviceTypesList);
  const ethnicArtistsServices = JSON.parse(data?.ethnicArtistsServices);
  const findEthnicWord = keyword?.split("-")[0];
  const ethnicWord =
    findEthnicWord[0]?.toUpperCase() +
    findEthnicWord?.substring(1).toLowerCase();
  const requireEthnicId = ethnicArtistsServices?.find(
    (i) => i?.name === ethnicWord
  );
  const ethnicArtistList = artistList?.filter(
    (art) => art?.ethnicArtistServices?._id === requireEthnicId?._id
  );


  //Rearange element
  const third = serviceTypesList[2];
  const ist = serviceTypesList[0];
  serviceTypesList[0] = third;
  serviceTypesList[2] = ist;
  const orderbyOptions = [
    {
      label: "Price",
      value: "price",
      selected: false,
    },
    // {
    //   label: "Nearest",
    //   value: "nearest",
    //   selected: false,
    // },
    {
      label: "popularity",
      value: "popularity",
      selected: false,
    },
    // {
    //   label: "Last minute appointment",
    //   value: "lastminute",
    //   selected: false,
    // },
  ];
  const showByOptions = [
    {
      label: "Individuals",
      value: "individuals",
      selected: false,
    },
  ];

  const serviceTypeOptions = [];
  serviceTypesList?.map((item, index) => {
    const key = item?.name?.toLowerCase()?.split(" ")?.join("-");
    const matchable = key?.search("'") === -1 ? key : key?.replace(/'/g, "");
    serviceTypeOptions?.push({
      label: item?.name,
      value: item?._id,
      selected: matchable === keyword,
      ...item,
    });
  });
  // const isNull = serviceTypeOptions.filter((item) => item.selected === true)[0]
  //   ?.name;
  // if (!isNull) {
  //   serviceTypeOptions[0].selected = true;
  // }
  const removeItem = [
    "60f65f72b35fea22c897f8e5",
    "60f65468b35fea22c897f8e0",
    "60f653e7b35fea22c897f8d9",
    "60f6545bb35fea22c897f8df",
    "60f65429b35fea22c897f8da",
    "60f65474b35fea22c897f8e1",
  ];
  const refactorServiceTypeOptions = [
    ...serviceTypeOptions.filter((i) => !removeItem.includes(i.value)),
    { headingLabel: "Ethnic skills" },
  ];
  ethnicArtistsServices?.map((item, index) => {
    refactorServiceTypeOptions?.push({
      label: item?.name,
      value: item?._id,
      selected: false,
      ...item,
      etnic: true,
    });
  });
  const allOptions = [
    {
      label: "Search",
      options: "",
    },
    {
      label: "Order by",
      options: orderbyOptions,
    },

    {
      label: "Services",
      options: refactorServiceTypeOptions,
    },
  ];
  if (typeof window !== "undefined") {
    const localFilters = localStorage.getItem("filters");
    // var savedFilters = JSON.parse(localFilters) || allOptions;
    var savedFilters = allOptions;
  }
  const [filters, setFilters] = React.useState(savedFilters);
  const [limit, setLimit] = React.useState(8);
  const [selectedServiceTypes, setSelectedServiceTypes] = React.useState(
    filters?.[2]?.options?.filter((item) => item?.selected) || []
  );

  const filterArtists = [];
  selectedServiceTypes.forEach((serviceType) => {
    artistList?.forEach((artist) => {
      const ethnicArtistExist =
        serviceType?.etnic &&
        artist?.ethnicArtistServices?._id === serviceType?._id;
      artist?.servicesList?.forEach((item) => {
        if (
          (item?.serviceTypeId === serviceType?._id || ethnicArtistExist) &&
          !filterArtists.find((item) => item?._id === artist?._id)
        ) {
          filterArtists?.push(artist);
        }
      });
    });
  });

  const clearFilters = () => {
    setFilters(allOptions);
    setSelectedServiceTypes([]);
    localStorage.removeItem("filters");
  };
  const applyFilters = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("filters", JSON.stringify(filters));
    }
    setSelectedServiceTypes(
      filters?.[2]?.options?.filter((item) => item?.selected)
    );
  };
  //keyword change accrding to constant file
  const key = selectedServiceTypes[0]?.name
    ?.toLowerCase()
    ?.split(" ")
    ?.join("-");
  const matchable = key?.search("'") === -1 ? key : key?.replace(/'/g, "");
  const pageData = homePageData?.filter((item) => item?.slug === keyword)[0];
  const dynamiPageData =
    homePageData.filter((item) => item?.slug === matchable)[0] ||
    homePageData.filter((item) => item?.slug === keyword)[0];

  //remoe makeup service artist if url is hair-salon
  const sortedArtist = artistList.filter((item) => {
    const isMakeupService = item?.servicesList?.find(
      (service) => service?.serviceTypeId === "60f6547eb35fea22c897f8e2"
    );
    if (!isMakeupService) {
      return item;
    }
  });
  const renderArtist =
    keyword === "hair-salon" && selectedServiceTypes.length === 0
      ? sortedArtist?.sort((a, b) => a.qi - b.qi)
      : requireEthnicId
      ? ethnicArtistList?.sort((a, b) => a.qi - b.qi)
      : filterArtists?.sort((a, b) => a.qi - b.qi);



      useEffect(() => {
        const timeout = setTimeout(() => {
          setIsLoading(false);
        }, 500);
        return () => clearTimeout(timeout);
      }, []);
    
      if (isLoading) {
        return  <Box
        display={"flex"}
        width="100%"
        height={"100%"}
        alignItems={"center"}
        overflow={"hidden"}
        justifyContent={"center"}
        position="absolute"
        top="0"
        left="0"
        zIndex="300"
        backgroundColor="white"
      >
        <CircleLoader loading={isLoading} />
      </Box>;
      }


  return (
    <Layout>
      <NextSeo
        title={
          pageData?.title ||
          "CoverClap: Find your Perfect Beauty Stylist in Montreal 2022"
        }
        description={
          pageData?.description ||
          "A live curation of Montreal's best stylists every day. Discover the latest hairstylists, colorists, makeup and nail artists... and more"
        }
        openGraph={{
          url: "https://coverclap.com/" + pageData.slug + "/montreal",
          type: "website",
          siteName: "CoverClap",
          images: [
            {
              url: "https://coverclap.com/new-ui/images/coverclap.png",
              width: 1200,
              height: 1076,
            },
          ],
        }}
      />
      {/* <HeroSection data={pageData} /> */}
      <Filterbar
        orderbyOptions={filters?.[1]}
        showByOptions={filters?.[0]}
        serviceTypeOptions={filters?.[2]}
        allOptions={filters}
        setFilters={setFilters}
        clearFilters={clearFilters}
        applyFilters={applyFilters}
      />
      <Box className={styles.searhResultHeading}>
        <h1>
          Search Result "
          <span className={styles.SearchText}>
            {`${selectedServiceTypes[0]?.name || keyword}`} near me in Montreal
          </span>
          "{" "}
          <span className={styles.totalResult}>
            {renderArtist?.length} results
          </span>
        </h1>
      </Box>
      <Box className={styles.mobileViewSearchText}>
        <>
          <Box className={styles.searhResultHeadingOnMobile}>Search Result</Box>
          <Box className={styles.searchTextMobileContainer}>
            "
            <span className={styles.SearchTextonMobile}>
              {selectedServiceTypes[0]?.name || keyword} near me in Montreal
            </span>
            "
          </Box>
          <Box className={styles.searchTextMobileContainerCount}>
            <span className={styles.totalResult}>
              {renderArtist?.length} results
            </span>
          </Box>
        </>
      </Box>
      <CardsBox
        serviceTypes={serviceTypesList}
        artists={renderArtist?.slice(0, limit)}
        selectedServiceTypes={selectedServiceTypes}
        homePageData={false}
        keywordPage={true}
        isHairSalons={true}
      />
      <Box px="20px">
        <Box
          margin="auto"
          marginTop={"-20px"}
          mb={["42px", "136px"]}
          width={["100%", "172px", "172px"]}
          height="54px"
          borderRadius={"full"}
        >
          {renderArtist?.length !== 0 ||
          (keyword === "hair-salon" && selectedServiceTypes.length === 0) ? (
            <UiButton
              onClick={() => {
                limit >= renderArtist?.length
                  ? setLimit(limit)
                  : setLimit(limit + 8);
              }}
              bgColor={"#64E0F5"}
              color={"#000000"}
              hFull
              label={"View More"}
            />
          ) : (
            <Box>Coming soon</Box>
          )}
        </Box>
      </Box>
      <QASection data={dynamiPageData?.qaSection} />
      <WhyShouldHire />
      <BlogSection blogList={dynamiPageData?.blogs} />
    </Layout>
  );
}

export default Home;

export async function getStaticProps() {
  let [artistList, serviceTypesList, ethnicArtistsServices] = await Promise.all(
    [
      Mongo.findAllWithPopulate(
        "Artist",
        { onBoarded: true, isActivated: true },
        [
          {
            path: "ethnicArtistServices",
            model: "EthnicArtists",
          },
          {
            path: "servicesList",
            model: "ArtistServices",
            match: {
              name: {
                $gte: " ",
              },
            },
            populate: {
              path: "images",
              model: "Artistimages",
            },
          },
        ]
      ),
      Mongo.findAll("ServiceTypes"),
      Mongo.findAll("EthnicArtists"),
    ]
  );

  const data = {
    // new structure
    artistList: JSON.stringify(artistList),
    serviceTypesList: JSON.stringify(serviceTypesList),
    ethnicArtistsServices: JSON.stringify(ethnicArtistsServices),
  };

  return {
    props: {
      data,
    },
    revalidate: 1,
  };
}

export async function getStaticPaths() {
  const filteredServiceTypes = [];
  homePageData?.map((item) => {
    filteredServiceTypes.push({ params: { keyword: `${item?.slug}` } });
    //  { params: { keyword: item?.slug } }
  });
  return {
    paths: filteredServiceTypes,
    fallback: false, // can also be true or 'blocking'
  };
}
